export default {
  itemList: {
    items: [], _links: {}, _meta: {}
  },
  itemDetail: {}
}
